import { EXPENSE_CATEGORIES } from '../../utils/categories';
import Select from '../UI/Select';
import { CalendarBlank, MapPin } from '@phosphor-icons/react';

// Sort expense categories alphabetically for dropdown
const SORTED_EXPENSE_CATEGORIES = [...EXPENSE_CATEGORIES].sort((a, b) => 
  a.label.localeCompare(b.label)
);

const CATEGORY_OPTIONS = [
  { value: '', label: 'All Categories' },
  ...SORTED_EXPENSE_CATEGORIES.map(cat => ({ value: cat.value, label: cat.label }))
];

const TYPE_OPTIONS = [
  { value: '', label: 'All Types' },
  { value: 'false', label: 'Actual Only' },
  { value: 'true', label: 'Planned Only' },
];

/**
 * ExpenseFilters - Category, type, year and trip filter controls
 */
export default function ExpenseFilters({ filter, onChange, years = [], trips = [], isOnline = true }) {
  // Build year options
  const yearOptions = [
    { value: '', label: 'All Years' },
    ...years.map(year => ({ value: year.toString(), label: year.toString() }))
  ];

  // Build trip options
  const tripOptions = [
    { value: '', label: 'All Trips' },
    ...trips.map(trip => ({ value: trip.id, label: trip.name }))
  ];

  // Is trip filter active? (Year filter is ignored when filtering by trip)
  const isTripSelected = !!filter.trip_id;

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Year filter - disabled when trip is selected since trip shows all years */}
      {isOnline && years.length > 0 && (
        <div className="flex items-center gap-1.5">
          <CalendarBlank 
            size={16} 
            style={{ color: isTripSelected ? 'var(--color-text-disabled)' : 'var(--color-text-muted)' }} 
          />
          <Select
            options={yearOptions}
            value={isTripSelected ? '' : (filter.year || '')}
            onChange={(value) => onChange({ ...filter, year: value })}
            className="w-28"
            disabled={isTripSelected}
            title={isTripSelected ? 'Year filter disabled when viewing a trip' : ''}
          />
        </div>
      )}

      {/* Trip filter */}
      {isOnline && trips.length > 0 && (
        <div className="flex items-center gap-1.5">
          <MapPin size={16} style={{ color: 'var(--color-text-muted)' }} />
          <Select
            options={tripOptions}
            value={filter.trip_id || ''}
            onChange={(value) => onChange({ ...filter, trip_id: value })}
            className="w-36"
          />
        </div>
      )}

      {/* Category filter */}
      <Select
        options={CATEGORY_OPTIONS}
        value={filter.category}
        onChange={(value) => onChange({ ...filter, category: value })}
        className="w-40"
      />

      {/* Type filter */}
      <Select
        options={TYPE_OPTIONS}
        value={filter.is_planned}
        onChange={(value) => onChange({ ...filter, is_planned: value })}
        className="w-36"
      />
    </div>
  );
}
